// extracted by mini-css-extract-plugin
export default {"component":"PriceMarketTotal_component__Z9pIE","element":"PriceMarketTotal_element__3W2WD"};